import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { Switch, Route, withRouter } from 'react-router';
import PropTypes from 'prop-types';

import configureStore from '../store/eventSubmissionStore';
import Layout from './../layout/Layout';
import SubmissionWizard from 'containers/SubmissionWizardContainer';
import CheckoutWizard from 'containers/CheckoutWizardContainer';
import SnapSellWizard from 'containers/SnapSellWizardContainer';
import AppContainer from 'containers/AppContainer';
import { StripeProvider } from 'react-stripe-elements';
import scrollTo from 'lib/utils/scrollTo';

class ScrollToTopComponent extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object,
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (window.gtag) {
        window.gtag('config', GTAG_TRACKING_ID, { 'page_path': `/form${this.props.location.pathname}` });
      }
      scrollTo(0);
      if (document.forms[0]) {
        document.forms[0].elements[0].focus();
      }
    }
  }

  render() {
    return this.props.children;
  }
}

const ScrollToTop = withRouter(ScrollToTopComponent);
const SnapSellContainer = (props) => <SnapSellWizard {...props} />;

const SubmissionApp = () => {
  return (
    <Switch>
      <Route path="/snap-sell" component={SnapSellContainer}/>
      <Route path="/checkout" component={CheckoutWizard}/>
      <Route path="/" component={SubmissionWizard}/>
    </Switch>
  );
};


const EventSubmissionApp = (props) => (
  <Provider store={configureStore(props)}>
    <Layout>
      <AppContainer loginRequired={false}>
        <HashRouter>
          <ScrollToTop>
            <StripeProvider apiKey={props.stripe_key}>
              <SubmissionApp />
            </StripeProvider>
          </ScrollToTop>
        </HashRouter>
      </AppContainer>
    </Layout>
  </Provider>
);

EventSubmissionApp.propTypes = {
  config: PropTypes.shape({
    app_path: PropTypes.string,
  }),
};

export default EventSubmissionApp;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/startup/EventSubmissionApp.jsx